import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/credit-suisse-cop-hackathon-sept16/credit-suisse-cop-hackathon-sept16/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Azure provides a lot of AI and Cognitive Services to build innovative Business Applications.`}</p>
    </PageDescription>
    <h3>{`Azure Databases`}</h3>
    <p><a parentName="p" {...{
        "href": "https://docs.microsoft.com/en-us/azure/?product=databases&ocid=AID3054457"
      }}>{`Azure Documentation - Databases`}</a></p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Azure Blob storage`}</strong>{`: Store unstructured objects, e.g. images, documents etc):`}</p>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.microsoft.com/en-us/azure/storage/blobs/?ocid=AID3054457"
            }}>{`Docs`}</a></li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Azure Cosmos DB`}</strong>{`: Fast NoSQL database, multiple APIs e.g. Gremlin (Graph), SQL, MongoDB, Cassandra, Table Storage`}</p>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.microsoft.com/en-us/azure/cosmos-db/?ocid=AID3054457"
            }}>{`Docs`}</a></li>
        </ul>
      </li>
    </ul>
    <h3>{`AI + Machine Learning`}</h3>
    <p><a parentName="p" {...{
        "href": "https://docs.microsoft.com/en-us/azure/?product=ai-machine-learning&ocid=AID3054457"
      }}>{`Azure Documentation - AI and Machine Learning`}</a></p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Azure Machine Learning`}</strong>{`: Train, test deploy your Machine Learning Models`}
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://ml.azure.com/?ocid=AID3054457"
            }}>{`ML Studio`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.microsoft.com/en-us/azure/machine-learning/?ocid=AID3054457"
            }}>{`Docs`}</a></li>
        </ul>
      </li>
    </ul>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Azure Applied AI Services`}</strong>{` `}
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.microsoft.com/en-us/azure/applied-ai-services/?ocid=AID3054457"
            }}>{`Overview`}</a></li>
          <li parentName="ul"><strong parentName="li">{`Form Recognizer`}</strong>{`: Extract text from forms and documents`}
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "https://docs.microsoft.com/en-us/azure/applied-ai-services/form-recognizer/?ocid=AID3054457"
                }}>{`Docs`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "https://formrecognizer.appliedai.azure.com/?ocid=AID3054457"
                }}>{`FormRecognizer Studio`}</a></li>
            </ul>
          </li>
          <li parentName="ul"><strong parentName="li">{`Cognitive Search`}</strong>{`: Build semanticly enriched, searchable document databases`}
            <ul parentName="li">
              <li parentName="ul">{`Docs: `}<a parentName="li" {...{
                  "href": "https://docs.microsoft.com/en-us/azure/search/?ocid=AID3054457"
                }}>{`https://docs.microsoft.com/en-us/azure/search/?ocid=AID3054457`}</a></li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Azure Cognitive Services`}</strong>{` Vision, Language, Speech `}</p>
        <ul parentName="li">
          <li parentName="ul">
            <p parentName="li"><a parentName="p" {...{
                "href": "https://docs.microsoft.com/en-us/azure/cognitive-services/?ocid=AID3054457"
              }}>{`Overview`}</a></p>
          </li>
          <li parentName="ul">
            <p parentName="li"><strong parentName="p">{`Computer Vision`}</strong>{`: OCR, Object detection, Image classification, Spatial Analysis …`}</p>
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "https://docs.microsoft.com/en-us/azure/cognitive-services/computer-vision/?ocid=AID3054457"
                }}>{`Docs`}</a></li>
            </ul>
          </li>
          <li parentName="ul">
            <p parentName="li"><strong parentName="p">{`Language Service`}</strong>{`: Text Analytics / Natural Language Processing, Text Classification, Translation, Language detection …`}</p>
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "https://docs.microsoft.com/en-us/azure/cognitive-services/language-service/?ocid=AID3054457"
                }}>{`Docs`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "https://language.azure.com/?ocid=AID3054457"
                }}>{`Language Studio`}</a></li>
            </ul>
          </li>
          <li parentName="ul">
            <p parentName="li"><strong parentName="p">{`Speech Service`}</strong>{`: Speech-to-Text / Text-to-Speech, Translation, Transcription, Voice Assistants, Intent recognition…`}</p>
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "https://docs.microsoft.com/en-us/azure/cognitive-services/speech-service?ocid=AID3054457"
                }}>{`Docs`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "https://speech.microsoft.com/?ocid=AID3054457"
                }}>{`Speech Studio`}</a></li>
            </ul>
          </li>
          <li parentName="ul">
            <p parentName="li"><strong parentName="p">{`Azure Maps`}</strong>{` : Maps, Search, Routing, Traffic, Weather, Time Zones, Geolocation, Geofencing, Map Data, Creator, and Spatial Operations`}</p>
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "https://docs.microsoft.com/en-us/azure/azure-maps/?ocid=AID3054457"
                }}>{`Docs`}</a></li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      